import { useQuery } from '@apollo/client'
import { redesSociais } from '@/core/data/redes-sociais'
import {
  RedesSociaisQueryQuery,
  RedesSociaisQueryQueryVariables
} from '@/core/types/graphql'
import { useUsuarioLogado } from '@/core/hooks/use-usuario-logado'
import { split } from '@/core/utils/split'

export const useRedesSociais = () => {
  const { usuarioLogado } = useUsuarioLogado()
  const marcaAtual = usuarioLogado?.marcas?.[0]?.id
  const redesSociaisQuery = useQuery<
    RedesSociaisQueryQuery,
    RedesSociaisQueryQueryVariables
  >(redesSociais, {
    variables: { marca: marcaAtual },
    fetchPolicy: 'cache-first',
    skip: !marcaAtual
  })

  return redesSociaisQuery.data?.redesSociais?.map(rede => {
    const [pack, name] = split(rede.icone, '|')

    return {
      ...rede,
      pack,
      name
    }
  })
}
